module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 33
// module chunks = 0 1